// components/About.jsx
import React from 'react';
import '../styles/About.css';
import aboutImage from '../assets/p1.png'; // Add your image

const About = () => {
  const features = [
    {
      icon: '🏅',
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured plumbers for your peace of mind.'
    },
    {
      icon: '⭐',
      title: '5-Star Service',
      description: 'Consistently rated 5 stars by our satisfied customers.'
    },
    {
      icon: '🔧',
      title: 'Expert Technicians',
      description: 'Highly trained professionals with years of experience.'
    },
    {
      icon: '💰',
      title: 'Upfront Pricing',
      description: 'Transparent pricing with no hidden fees or surprises.'
    },
    {
      icon: '⚡',
      title: 'Same-Day Service',
      description: 'Fast response times with same-day service availability.'
    },
    {
      icon: '🕐',
      title: '24/7 Availability',
      description: 'Round-the-clock emergency service for urgent plumbing needs.'
    }
  ];

  const whyChooseUs = [
    {
      icon: '✅',
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured for your protection and peace of mind.'
    },
    {
      icon: '⭐',
      title: 'Experienced Professionals',
      description: 'Years of experience handling all types of plumbing issues.'
    },
    {
      icon: '💰',
      title: 'Transparent Pricing',
      description: 'Upfront pricing with no hidden fees or surprise charges.'
    },
    {
      icon: '⚡',
      title: 'Same-Day Service',
      description: 'Fast response times and same-day service availability.'
    },
    {
      icon: '🛡️',
      title: '100% Satisfaction Guarantee',
      description: 'We stand behind our work with a satisfaction guarantee.'
    },
    {
      icon: '🔧',
      title: 'Advanced Equipment',
      description: 'Using the latest tools and technology for efficient repairs.'
    },
    {
      icon: '👨‍🔧',
      title: 'Background Checked',
      description: 'All plumbers are background checked and drug tested.'
    },
    {
      icon: '📞',
      title: '24/7 Support',
      description: 'Around-the-clock customer support for emergencies.'
    }
  ];

  return (
    <section id="about" className="about">
      {/* Animated Background */}
      <div className="about-bg">
        <div className="about-bg-circle about-bg-circle-1"></div>
        <div className="about-bg-circle about-bg-circle-2"></div>
        <div className="about-bg-circle about-bg-circle-3"></div>
      </div>

      <div className="about-container">
        {/* About Section */}
        <div className="about-grid">
          {/* Left Content */}
          <div className="about-content">
            <span className="about-subtitle">About Us</span>
            <h2 className="about-title">
              Your Trusted <span className="about-title-highlight">Plumbing Experts</span>
            </h2>
            <p className="about-description">
              At <strong>PlumberPro</strong>, we pride ourselves on delivering 
              top-quality plumbing services with integrity, professionalism, and 
              unmatched expertise. With years of experience serving homeowners 
              and businesses, we've built a reputation for reliability and excellence.
            </p>
            <p className="about-description">
              Our team of licensed plumbers uses the latest tools and techniques 
              to diagnose and resolve any plumbing issue efficiently. From minor 
              repairs to major installations, we handle it all with precision and care.
            </p>

            {/* Feature Grid */}
            <div className="about-features">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="about-feature"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <span className="about-feature-icon">{feature.icon}</span>
                  <div className="about-feature-content">
                    <h4 className="about-feature-title">{feature.title}</h4>
                    <p className="about-feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="about-buttons">
              <button className="about-btn-primary" onClick={() => {
                window.location.href = 'tel:+18334936242';
              }}>
                <span className="about-btn-shine"></span>
                Get a Free Quote
              </button>
              <a href="tel:+18334936242" className="about-btn-secondary">
                📞 +1 (833) 493-6242
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="about-image-wrapper">
            <div className="about-image-glow"></div>
            <div className="about-image-container">
              <img 
                src={aboutImage} 
                alt="Professional Plumber" 
                className="about-image"
              />
              {/* Floating Stats */}
              <div className="about-stat-card about-stat-card-1">
                <span className="about-stat-number">500+</span>
                <span className="about-stat-label">Happy Customers</span>
              </div>
              <div className="about-stat-card about-stat-card-2">
                <span className="about-stat-number">4.9★</span>
                <span className="about-stat-label">Average Rating</span>
              </div>
              <div className="about-stat-card about-stat-card-3">
                <span className="about-stat-number">10+</span>
                <span className="about-stat-label">Years Experience</span>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="why-choose-us">
          <div className="why-choose-us-header">
            <span className="why-choose-us-subtitle">Why Choose Us</span>
            <h2 className="why-choose-us-title">
              Why <span className="why-choose-us-highlight">PlumberPro</span>?
            </h2>
            <p className="why-choose-us-description">
              Here's why thousands of customers trust us with their plumbing needs.
            </p>
          </div>

          <div className="why-choose-us-grid">
            {whyChooseUs.map((item, index) => (
              <div 
                key={index} 
                className="why-choose-us-card"
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <div className="why-choose-us-card-icon">{item.icon}</div>
                <h4 className="why-choose-us-card-title">{item.title}</h4>
                <p className="why-choose-us-card-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;